import { FunctionComponent } from "react";
import { ParseHtml } from "@pjs/security";
import { userUiI18n } from "../i18n/UserUiI18n.const";
import { ITemporaryAccessInstructionsProps } from "./interfaces/ITemporaryAccessInstructionsProps";

export const TemporaryAccessInstructions: FunctionComponent<ITemporaryAccessInstructionsProps> = (props) => {
    return (
        <div className="uui-temporary-access__instruction-container">
            <h3 className="uui-temporary-access__title">{userUiI18n.getString("temporary_access.how_temporary_access_works.title")}</h3>
            <p className="uui-temporary-access__description">{userUiI18n.getString("temporary_access.how_temporary_access_works.description")}</p>
            <p className="uui-temporary-access__description">{userUiI18n.getString("temporary_access.how_temporary_access_works.email_notification")}</p>
            {props.supplementaryInformation !== undefined && (
                <ParseHtml className="uui-temporary-access__description" htmlString={props.supplementaryInformation} />
            )}
        </div>
    );
};
